import styled from 'styled-components';

import { media } from '@/shared/ui/core';

export const BackButton = styled.button.attrs({
  className: 'BackButton',
})`
  background: transparent;
  border: none;
  display: block;
  width: 2.25rem;
  max-width: 25rem;
  height: 2.25rem;
  padding: 0.25rem;
  margin-left: 0.75rem;
  position: fixed;
  top: calc(0.875rem + var(--notch-height));
  align-self: flex-start;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 120;
  cursor: pointer;

  @media ${media.desktopMin} {
    display: none;
  }
`;
